<template>
    <AppLoadingContainer :predicate="!isLoaded">
        <form @submit.prevent="canEdit ?onSubmit() : null" v-if="organization">
            <div class="card-body">
                <div class="row">
                    <div class="col-lg-2 col-sm-6 form-group">
                        <label for="Code">Code</label>
                        <input autocomplete="off" class="form-control" disabled
                               placeholder="Code" v-model="organization.code"/>
                    </div>
                    <div class="col-lg-6 col-sm-6 form-group">
                        <label for="Name">FAMIS Name</label>
                        <input autocomplete="off" class="form-control" disabled
                              placeholder="Name" v-model="organization.name"/>
                    </div>
                    <div class="col-lg-4 col-sm-6 form-group">
                        <label for="Code">Program Manager</label>
                        <input autocomplete="off" class="form-control" disabled
                               placeholder="Program Manager" v-model="organization.programManagerName"/>
                    </div>
                </div>

                <div class="row">
                    <div class="col-lg-6 col-sm-6 form-group">
                        <label for="Name">Preferred Name</label>
                        <input autocomplete="off" class="form-control" :disabled="!canEdit"
                              placeholder="Name" v-model="organization.preferredName"/>
                    </div>
                </div>

                <div class="row">
                    <div class="col-lg-4 col-sm-6 form-group">
                        <label for="Type">Type</label>
                        <select :disabled="!canEdit" class="form-control" v-model="organization.type">
                            <option :value="null" disabled>-- Select Organization Type --</option>
                            <option>Group</option>
                            <option>Division</option>
                            <option>Program</option>
                        </select>
                    </div>
                    <div class="col-lg-4 col-sm-6 form-group">
                        <label for="ReportGroupOrganizationId">Report Grouping</label>
                        <select :disabled="!canEdit" class="form-control"
                                v-model="organization.reportGroupOrganizationId">
                            <option :key="org.id" :value="org.id" v-for="org in organizationList">{{org.code}}
                            </option>
                        </select>
                    </div>
                    <div class="col-lg-4 col-sm-6 form-group">
                        <label for="ParentOrganizationId">Parent Organization</label>
                        <select :disabled="!canEdit" class="form-control" v-model="organization.parentOrganizationId">
                            <option :key="org.id" :value="org.id" v-for="org in organizationList">{{org.code}}
                            </option>
                        </select>
                    </div>
                </div>

                <div class="row">
                    <div class="col-lg-4 col-sm-6 form-group">
                        <AppCheckBox :disabled="!canEdit"
                                     v-model="organization.isActive">Is Active
                        </AppCheckBox>
                    </div>
                    <div class="col-lg-4 col-sm-6 form-group">
                        <AppCheckBox :disabled="!canEdit"
                                     v-model="organization.peopleIndicator">People Indicator
                        </AppCheckBox>
                    </div>
                </div>
            </div>
            <div class="card-footer d-print-none text-right">
                <button :disabled="isSubmitting" class="btn btn-primary" type="submit" v-if="canEdit">Save</button>
                <RouterLink :disabled="isSubmitting" :to="{name:'Organizations'}" class="btn btn-danger">Back
                </RouterLink>
            </div>
        </form>
    </AppLoadingContainer>
</template>

<script>
    import OrganizationService from "../../services/OrganizationService";
    import AppCheckBox from "@/components/shared/AppCheckBox";
    import AppLoadingContainer from "@/components/shared/AppLoadingContainer";
    import {ToastType} from "@/services/models/shared/ToastType";
    import {ApplicationRole} from "@/services/models/Role";

    export default {
        components: {
            AppLoadingContainer,
            AppCheckBox,
        },
        data() {
            return {
                organization: {},
                organizationList: [],
                isSubmitting: false,
                isLoaded: false
            }
        },
        props: {
            organizationId: {
                type: String,
                required: true
            }
        },
        computed: {
            /**
             * @description Indicates if this form can be edited by the person based on the given role
             * @returns {boolean}
             */
            canEdit() {
                return this.hasApplicationRole(ApplicationRole.DatabaseAdministrator, ApplicationRole.Business, ApplicationRole.TTIWebsiteAdministrator);
            }
        },
        methods: {
            onSubmit() {
                if (!this.canEdit)
                    return;

                const vm = this;
                this.isSubmitting = true;

                OrganizationService.updateOrganization(vm.organization)
                    .then(() => {
                        vm.alert(ToastType.Success, "The organization was successfully updated")
                    }).catch(error => {
                    vm.alert(ToastType.Danger, error.response.statusText)
                }).finally(() => vm.isSubmitting = false);
            }
        },
        created() {
            const vm = this;

            Promise.all([
                // Retrieve this specific organization
                OrganizationService.getOrganization(vm.organizationId)
                    .then(function (response) {
                        vm.organization = response;
                    }),

                // Retrieving all organizations
                OrganizationService.getAllOrganizations()
                    .then(function (responses) {
                        vm.organizationList = responses;
                    })]).catch(() => {
                vm.redirectToError();
            }).finally(() => vm.isLoaded = true)
        }
    }
</script>
